import EditLanguageToggle from './EditLanguageToggle';

export default EditLanguageToggle;
